import React, { useCallback, useRef, useState } from 'react';
import { CustomButton } from '../../../../components/Button/Button';
import { Icon } from '../../../../components/Icon';
import styles from './SidebarButton.module.scss';
import cx from 'classnames';
import Tooltip from '../../../../components/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import SidebarButtonBadge from '../../../../components/SidebarButtonBadge/SidebarButtonBadge';

const SidebarButton = ({
  visible = true,
  disabled = false,
  label,
  icon,
  secondIcon,
  mini,
  onClick,
  hoverText,
  hoverOnDisabled,
  classNameButton,
  classNameTooltip = {},
  classNameWrapper = {},
  badgeText = null,
  tabIndex,
}) => {
  const [isHover, setIsHover] = useState(false);
  const wrapperRef = useRef(null);

  const toggleMouseEnter = useCallback(() => {
    if (hoverText && !isHover) {
      const hover = hoverOnDisabled ? disabled : true;
      hover && setIsHover(true);
    }
  }, [hoverText, hoverOnDisabled, disabled, isHover]);
  const { t } = useTranslation();

  const toggleMouseLeave = useCallback(() => {
    setIsHover(false);
  }, [setIsHover]);

  return visible ? (
    <div className={styles.sidebarContainer}>
      <div
        className={cx(styles.wrapper, classNameWrapper, { [styles.btnMini]: mini })}
        onMouseOver={toggleMouseEnter}
        onMouseLeave={toggleMouseLeave}
        ref={wrapperRef}
      >
        <CustomButton
          onMouseOver={toggleMouseEnter}
          onMouseOut={toggleMouseLeave}
          className={cx(styles.button, classNameButton)}
          variant="link"
          disabled={disabled}
          onClick={onClick}
          ignoreDisabled={hoverText && !mini}
          ariaLabel={!label && hoverText}
          tabIndex={tabIndex}
        >
          {icon && <Icon src={icon} verticalAlign="middle" className={styles.icon} />}
          <div className={styles.labelContainer}>
            {label && <span className={styles.buttonLabel}>{label}</span>}
            {secondIcon && <Icon src={secondIcon} verticalAlign="middle" className={styles.secondIcon} />}
            {badgeText && !mini && (
              <SidebarButtonBadge variant="secondary" className={styles.newBadge} text={badgeText} pulse={false} />
            )}
          </div>
        </CustomButton>
      </div>
      {!mini && (
        <Tooltip text={hoverText} isHover={isHover} classNameTooltip={classNameTooltip} wrapperRef={wrapperRef} y_offset={10} />
      )}
    </div>
  ) : null;
};

export default SidebarButton;
